import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import dashboardPreview from '../images/commonbg.png'

gsap.registerPlugin(ScrollTrigger)

function Commandcenter() {
  const sectionRef = useRef(null)
  const eyebrowRef = useRef(null)
  const titleRef = useRef(null)
  const textRef = useRef(null)
  const previewRef = useRef(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: 'top 78%',
          once: true,
        },
        defaults: { ease: 'power3.out' },
      })

      tl.from(eyebrowRef.current, {
        opacity: 0,
        y: 18,
        duration: 0.45,
      })
        .from(titleRef.current, {
          opacity: 0,
          y: 24,
          duration: 0.55,
        }, '-=0.1')
        .from(textRef.current, {
          opacity: 0,
          y: 18,
          duration: 0.45,
        }, '-=0.2')
        .from(previewRef.current, {
          opacity: 0,
          y: 28,
          scale: 0.97,
          duration: 0.7,
        }, '-=0.15')
    }, sectionRef)

    return () => ctx.revert()
  }, [])

  return (
    <section className="cc-section" ref={sectionRef}>
      <div className="cc-container">
        <span className="cc-eyebrow" ref={eyebrowRef}>Command Center</span>

        <h2 className="cc-title" ref={titleRef}>
          Control Every Bid,
          <br />
          Track Every Win,
          <br />
          Own The Arena.
        </h2>

        <p className="cc-text" ref={textRef}>
          The OBC Dashboard is more than an account page - it&apos;s your live trading command
          center. Monitor active auctions, track bids in real time, manage weekly bundle
          shipments, and organize every collectible inside your Vault with a high-performance
          interface designed for serious collectors.
        </p>

        <div className="cc-preview" ref={previewRef}>
          <img
            src={dashboardPreview}
            alt="OBC Dashboard preview"
            className="cc-preview-img"
          />
        </div>
      </div>
    </section>
  )
}

export default Commandcenter
